import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null
    };
  }

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      let errorMessage = 'Ha ocurrido un error inesperado.';
      let firestoreInfo = null;

      try {
        if (this.state.error?.message) {
          firestoreInfo = JSON.parse(this.state.error.message);
          if (firestoreInfo.error && firestoreInfo.operationType) {
            errorMessage = `Error de base de datos: ${firestoreInfo.operationType} en ${firestoreInfo.path || 'ruta desconocida'}.`;
          }
        }
      } catch (e) {
        // Not a JSON error message, use default
      }

      return (
        <div className="min-h-screen bg-app-bg flex flex-col items-center justify-center p-8 text-center font-sans">
          <div className="w-20 h-20 bg-mult-tp/10 rounded-full flex items-center justify-center mb-8 border border-mult-tp/20 shadow-sm">
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-mult-tp"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          </div>
          <h1 className="text-3xl font-black text-primary mb-3 tracking-tight">¡Vaya! Algo salió mal</h1>
          <p className="text-secondary mb-10 max-w-md text-sm font-medium leading-relaxed">{errorMessage}</p>
          
          {firestoreInfo && (
            <div className="bg-card-bg border border-grid-line rounded-2xl p-6 mb-10 text-left w-full max-w-xl overflow-auto shadow-card">
              <p className="text-[10px] font-bold text-muted uppercase tracking-[0.2em] mb-4">Detalles Técnicos</p>
              <pre className="text-xs text-secondary font-mono bg-board-bg p-4 rounded-xl border border-grid-line overflow-x-auto">
                {JSON.stringify(firestoreInfo, null, 2)}
              </pre>
            </div>
          )}

          <button
            onClick={() => window.location.reload()}
            className="px-8 py-4 bg-primary-accent hover:opacity-90 text-white rounded-2xl font-black text-xs uppercase tracking-[0.2em] transition-all shadow-sm active:scale-95"
          >
            Recargar aplicación
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
